export default __webpack_public_path__ + "static/home-slider-5-329b4744b2c020171328f18951272f07.jpg";